<template>
    <div>
        <div style="background-color:black !important;padding:2rem 0 ">
            <section class="container card" >
                <Transition  name="fade" appear >
                    <div class="row "  >
                        <div class="col-12 col-md-8 m-auto  p-5" >
                            <h2 class="title-subtitle text-center" style="font-weight:bold;color:white;font-size:1rem">Marina SaMont</h2>
                            <p class="text-center" style="letter-spacing: 4px;color:white;padding-bottom: 2rem;font-size: 10px !important;font-style:italic">Monterrey, México 1985</p>
                            
                            <p v-if="$store.state.lang == 'es'" style="line-height:1.5rem" class="text-justify" v-html="content.cv_es"></p>
                            <p v-else v-html="content.cv_en" style="line-height:1.5rem" class="text-justify" ></p>
                        </div>
                    </div>
                </Transition>
            </section>
        </div>

        <section class="container card" >
            <Transition  name="fade" appear >
                <div class="row " >
                    <div class="col-12 col-md-8 m-auto p-5" data-aos="fade-up">
                        <h2 class="subtitle" v-if="$store.state.lang == 'es'">Educación:</h2>
                        <h2 class="subtitle" v-else>Education:</h2>
                        <div>
                            <div v-for="(year,x) in profesional" :key="x" class="p-2" >
                                <div class="row ">
                                    <div class="col-md-1 col-2 text-nowrap"><p><span>{{ x }}</span></p></div>
                                    <div class="col-md-11 col-10">
                                        <p v-for="(ex,y) in year" :key="y" class="pb-5 pb-md-1"> 
                                            {{$store.state.lang == 'en' ? ex.degree_en : ex.degree_es }}, {{ex.institution }}. {{ ex.place }}, {{ ex.country }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div v-for="(exp,x) in studies" :key="x" class="p-2" >
                                <div class="row" >
                                    <div class="col-md-1 col-2 text-nowrap"><p><span>{{ exp.year }}</span></p></div>
                                    <div class="col-md-11 col-10">
                                        <p v-for="(ex,y) in exp.exhibitions" :key="y" class="pb-5 pb-md-1"> 
                                            {{$store.state.lang == 'en' ? ex.degree_en : ex.degree_es }}, {{ex.institution }}. {{ ex.place }}, {{ ex.country }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-12 col-md-8 m-auto p-5"  data-aos="fade-up">
                        <h2 class="subtitle" v-if="$store.state.lang == 'es'">Exposiciones individuales:</h2>
                        <h2 class="subtitle" v-else>Individual exhibitions:</h2>
                        <div>
                            <div v-for="(exp,x) in individuals" :key="x" class="p-2" >
                                <div class="row" >
                                    <div class="col-md-1 col-2 text-nowrap"><p><span>{{ exp.year }}</span></p></div>
                                    <div class="col-md-11 col-10">
                                        <p v-for="(ex,z) in exp.exhibitions" :key="z" class="pb-5 pb-md-1"> 
                                            {{ ex.name }}{{ex.gallery != null ? ', '+ex.gallery : '' }}. {{ ex.city }}, {{ ex.country }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-8 m-auto p-5"  data-aos="fade-up">
                        <h2 class="subtitle" v-if="$store.state.lang == 'es'">Exposiciones colectivas:</h2>
                        <h2 class="subtitle" v-else>Selected Group exhibitions:</h2>
                        <div>
                            <div v-for="(exp,x) in exhibitions" :key="x" class="p-2" >
                                <div class="row" >
                                    <div class="col-md-1 col-2 text-nowrap"><p><span>{{ exp.year }}</span></p></div>
                                    <div class="col-md-11 col-10">
                                        <p v-for="(ex,z) in exp.exhibitions" :key="z" class="pb-5 pb-md-1"> 
                                            {{ ex.name }}{{ex.gallery != null ? ', '+ex.gallery : '' }}. {{ ex.city }}, {{ ex.country }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-8 m-auto p-5" data-aos="fade-up" >
                        <h2 class="subtitle" v-if="$store.state.lang == 'es'">Publicaciones:</h2>
                        <h2 class="subtitle" v-else>Publishing:</h2>
                        <div>
                            <div v-for="(exp,x) in books" :key="x" class="p-2" >
                                <div class="row">
                                    <div class="col-md-1 col-2 text-nowrap"><p><span>{{ exp.year }}</span></p></div>
                                    <div class="col-md-11 col-10">
                                        <p v-for="(book,y) in exp.exhibitions" :key="y" class="pb-5 pb-md-1"> 
                                            {{ book.title }}, {{book.publisher }}. {{ book.author }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-8 m-auto p-5" data-aos="fade-up" >
                        <h2 class="subtitle" v-if="$store.state.lang == 'es'">Prensa:</h2>
                        <h2 class="subtitle" v-else>Press:</h2>
                        <div>
                            <div v-for="(exp,x) in press" :key="x" class="p-2" >
                                <div class="row">
                                    <div class="col-md-1 col-2 text-nowrap"><p><span>{{ exp.year }}</span></p></div>
                                    <div class="col-md-11 col-10">
                                        <p v-for="(news,y) in exp.exhibitions" :key="y" class="pb-5 pb-md-1"> 
                                            {{ news.title }}, {{news.publisher }}. {{ news.author }} <a :href="news.external_link" class="link" target="_blank" v-if="news.external_link != '' && news.external_link != null"><svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#959595"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z"/></svg></a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>                    
                    </div>                    
                </div>
            </Transition>
        </section>
    </div>
</template>

<script >
import moment from 'moment';
import axios from 'axios'
import {_} from 'vue-underscore';
export default {
    name: 'ArtistComponent',

    data(){
        return{
            artist: 'Marina SaMont',
            profesional: [],
            individuals: [],
            exhibitions: [],
            studies: [],
            books:[],
            press:[],
            content:{}
        }
    },
    created(){
        this.getArtistData()
        this.getIndividuals()
        this.getExhibitions()
        this.getProfesional()
        this.getStudies()
        this.getBooks()
        this.getPress()
    },
  
    methods:{
        format(date,format){
            return moment(date).format(format)
        },

        getArtistData(){
            axios.get(this.$url+'/artist',{
                headers: {'Content-Type' : 'application/json'}
            })
            .then((res)=>{
                this.content = res.data
            }).catch((err)=>{
                console.log(err)
            })
        },
        getExhibitions(){
            axios.get(this.$url+'/exhibitionsp',{
                headers: {'Content-Type' : 'application/json'}
            })
            .then((res)=>{
                this.exhibitions = res.data
               this.exhibitions = this.sortArrByYear(this.exhibitions)
            }).catch((err)=>{
                console.log(err)
            })
        },
        getIndividuals(){
            axios.get(this.$url+'/individualsp',{
                headers: {'Content-Type' : 'application/json'}
            })
            .then((res)=>{
                this.individuals = res.data
               this.individuals = this.sortArrByYear(this.individuals)
            }).catch((err)=>{
                console.log(err)
            })
        },
        getProfesional(){
            axios.get(this.$url+'/profesional',{
                headers: {'Content-Type' : 'application/json'}
            })
            .then((res)=>{
                this.profesional = res.data
            }).catch((err)=>{
                console.log(err)
            })
        },
        getStudies(){
            axios.get(this.$url+'/studies',{
                headers: {'Content-Type' : 'application/json'}
            })
            .then((res)=>{
                this.studies = res.data
                this.studies = this.sortArrByYear(this.studies)
            }).catch((err)=>{
                console.log(err)
            })
        },
        getBooks(){
            axios.get(this.$url+'/books',{
                headers: {'Content-Type' : 'application/json'}
            })
            .then((res)=>{
                this.books = res.data
                this.books = this.sortArrByYear(this.books)
            }).catch((err)=>{
                console.log(err)
            })
        },
        getPress(){
            axios.get(this.$url+'/press',{
                headers: {'Content-Type' : 'application/json'}
            })
            .then((res)=>{
                this.press = res.data
                this.press = this.sortArrByYear(this.press)

            }).catch((err)=>{
                console.log(err)
            })
        },
        
       sortArrByYear(jsonData) {
            let exhibitionsArray = Object.keys(jsonData).map(year => ({
                year: year,
                exhibitions: jsonData[year]
            }));

            // Ordenar el arreglo por año de manera descendente (de más reciente a más antiguo)
            exhibitionsArray.sort((a, b) => b.year - a.year);
            return exhibitionsArray
       }
    }
}
</script>